import { View } from "react-native"
import BFText from "@/components/standard/BFText"

interface BadgeProps {
  badge: number
}

export default function Badge({ badge }: BadgeProps) {
  return (
    <View className="flex items-center justify-center min-w-[18px] h-[14px] rounded-[10px] bg-red px-1">
      <BFText className="font-spacegrotesk text-[10px] text-white">
        {badge > 99 ? "99+" : badge}
      </BFText>
    </View>
  )
}
